import { reactive } from 'vue';

export const loadingState = reactive({
    activeRequests: 0,
    get isLoading() {
        return this.activeRequests > 0;
    },
    start() {
        this.activeRequests++;
    },
    stop() {
        if (this.activeRequests > 0) this.activeRequests--;
    }
});
